export default "__VITE_ASSET__1hZLRo9I__"